'use client'

import { Button } from '@dxp/components/button'
import { Drawer, DrawerHeader } from '@dxp/components/drawer'
import { Icon } from '@dxp/components/icon'
import { Box, IconButton, Typography } from '@mui/material'
import { useState } from 'react'

import styles from './help-tray.module.scss'

interface HelpTrayProps {
  open?: boolean
  onOpen?: () => void
  onClose?: () => void
  title: string
  content: string
  buttonText: string
  buttonVariant?: 'text' | 'contained' | 'outlined'
}

export const HelpTray = (props: HelpTrayProps) => {
  const [helpTrayOpen, setHelpTrayOpen] = useState(false)
  const { title, content, buttonText, buttonVariant, open, onOpen, onClose } =
    props

  const isControlled = open !== undefined
  const isOpen = isControlled ? open : helpTrayOpen

  const handleOpen = () => {
    if (!isControlled) {
      setHelpTrayOpen(true)
    }
    onOpen?.()
  }

  const handleClose = () => {
    if (!isControlled) {
      setHelpTrayOpen(false)
    }
    onClose?.()
  }

  return (
    <>
      {/* Trigger */}
      <Button variant={buttonVariant} onClick={handleOpen}>
        {buttonText}
      </Button>

      {/* Drawer */}
      <Drawer
        open={isOpen}
        variant="temporary"
        onClose={handleClose}
        slotProps={{
          backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.1)' } },
          paper: { className: styles.drawer },
        }}
      >
        <DrawerHeader>
          <Typography variant="h3">{title}</Typography>

          <Box
            sx={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Icon icon="Cross" size="md" color="primary" />
            </IconButton>
          </Box>
        </DrawerHeader>

        <Box className={styles.content}>{content}</Box>
      </Drawer>
    </>
  )
}
